import { formatSalesOrderNumber } from '@order-management/format';
import { SalesOrdersAccessTableRow } from '@order-management/types';
import Link from '../../ui/link/link';
import PaginatedTable, {
  CustomPaginatedTableProps,
} from '../../ui/table/paginated-table/paginated-table';
import { Column } from '../../ui/table/types';

export type AdminTemporaryAccessSalesOrdersTableProps =
  CustomPaginatedTableProps<SalesOrdersAccessTableRow>;

export const columns: Column<SalesOrdersAccessTableRow>[] = [
  {
    key: 'number',
    title: 'Sales Order',
    className: 'is-width-15',
    render: (el) => (
      <Link to={`sales-orders/${el.id}`}>
        {formatSalesOrderNumber(el.number)}
      </Link>
    ),
    sortable: true,
  },
  {
    key: 'opportunity.name',
    title: 'Opportunity name',
    className: 'is-width-25',
    render: (el) => el.opportunity?.name,
    sortable: true,
  },
  {
    key: 'opportunity.account.name',
    title: 'Account',
    className: 'is-width-20',
    render: (el) => el.opportunity?.account?.name,
    sortable: true,
  },
  {
    key: 'softwareTitles',
    className: 'is-width-10',
    render: (el) => el.softwareTitles.total,
    title: 'Software titles',
    sortable: false,
  },
  {
    key: 'devices',
    className: 'is-width-10',
    render: (el) => el.devices.total,
    title: 'Devices',
    sortable: false,
  },
  {
    key: 'endUser',
    title: 'User',
    className: 'is-width-20',
    render: (el) => el.endUser,
    sortable: false,
  },
];

export function AdminTemporaryAccessSalesOrdersTable({
  form,
  dataSource,
  onChange,
  config,
  empty,
  rowSelection,
  errorMessage,
}: AdminTemporaryAccessSalesOrdersTableProps) {
  return (
    <PaginatedTable
      form={form}
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      config={config}
      rowKey={'id'}
      empty={empty}
      rowSelection={rowSelection}
      errorMessage={errorMessage}
    />
  );
}

export default AdminTemporaryAccessSalesOrdersTable;
